export default {
  DRIP: {
    ID: 1,
    NAME: 'drip',
    METHOD_NAME: 'method.drip',
    BEANS_AMOUNT: 12,
    WATER_AMOUNT: 200,
    MAKE_TIME: 1800,
    IMG: '/static/img/pics/drip.jpg',
    TIME_BLOOM: 300,
    TIME_SECOND_POUR: 900,
    TIME_THIRD_POUR: 1500
  },
  FRENCH: {
    ID: 2,
    NAME: 'french',
    METHOD_NAME: 'method.french',
    BEANS_AMOUNT: 13,
    WATER_AMOUNT: 200,
    MAKE_TIME: 2400,
    IMG: '/static/img/pics/french.jpg',
    TIME_FIRST_MSG: 300
  },
  AERO: {
    ID: 3,
    NAME: 'aero',
    METHOD_NAME: 'method.aero',
    BEANS_AMOUNT: 13,
    WATER_AMOUNT: 200,
    MAKE_TIME: 1200,
    IMG: '/static/img/pics/aero.jpg',
    TIME_FIRST_MSG: 600
  },
  INTERVAL_COUNTUP: 100,
  INTERVAL_DO_COUNTDOWN: 1000
}



// WEBPACK FOOTER //
// ./src/constants/index.js